import "core-js/modules/es6.string.link";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import RegularSubtitle from '~/components/atoms/Global/RegularSubtitle.vue';

var MediaAndOverlay = function MediaAndOverlay() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/molecules/Global/MediaAndOverlay.vue');
};

var SHORT_LIST_MAX_LENGTH = 6;
export default {
  name: 'LookbookPush',
  components: {
    MediaAndOverlay: MediaAndOverlay,
    RegularTitle: RegularTitle,
    RegularSubtitle: RegularSubtitle
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showAll: false
    };
  },
  computed: {
    elements: function elements() {
      var _this = this;

      return this.payload.items.map(function (item) {
        var small = formatPrismicImage(item.image.url, [['w_375'], ['c_crop', "ar_".concat(_this.ratio)]]) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, [['w_375,dpr_2'], ['c_crop', "ar_".concat(_this.ratio)]]) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, [['w_1440'], ['c_crop', "ar_".concat(_this.ratio)]]) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, [['w_1440,dpr_2'], ['c_crop', "ar_".concat(_this.ratio)]]) || EMPTY_PIXEL;
        var isObjectEmpty = Object.keys(item.title).length === 0;
        return {
          src: small,
          srcset: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
          url: item.link.url,
          alt: item.alt,
          title: isObjectEmpty ? '' : item.title[0].text,
          titleLevel: isObjectEmpty ? '' : item.title[0].type,
          titleColor: item.title_color || '',
          subtitle: isObjectEmpty || _this.isMobile() ? '' : item.subtitle[0].text,
          subtitleLevel: isObjectEmpty ? '' : item.subtitle[0].type,
          subtitleColor: item.subtitle_color || '',
          gradient: item.gradient === 'YES',
          opacity: item.opacity === 'YES',
          layer: item.layer === 'YES',
          videoWebm: item.video_src_webm ? formatPrismicImage(item.video_src_webm.url, [['w_375'], ['c_fill', "ar_".concat(_this.ratio)]], '', 'video') : null,
          videoMp4: item.video_src_mp4 ? formatPrismicImage(item.video_src_mp4.url, [['w_375'], ['c_fill', "ar_".concat(_this.ratio)]], '', 'video') : null,
          autoPlay: item.auto_play === 'YES',
          iconPlayColor: item.video_play_icon_color || '#3C3C3B',
          ratio: _this.ratio,
          tracking: {
            data: {
              event_category: item.event_category,
              event_action: item.event_action,
              event_label: item.event_label
            }
          }
        };
      });
    },
    spacing: function spacing() {
      switch (this.payload.primary.margin) {
        case 'negative':
          return 'spacer-negative';

        case 'none':
          return 'spacer-0';

        case 'small':
          return 'spacer-s';

        case 'medium':
          return 'spacer-m';

        case 'large':
          return 'spacer-l';

        default:
          return '';
      }
    },
    showMore: function showMore() {
      return this.payload.primary.show_more === 'YES' && this.elements.length >= SHORT_LIST_MAX_LENGTH;
    },
    lastElementIndex: function lastElementIndex() {
      if (this.showAll) return this.elements.length;
      return this.showMore ? SHORT_LIST_MAX_LENGTH : this.elements.length;
    },
    ratio: function ratio() {
      return this.payload.items[0].ratio;
    }
  },
  methods: {
    handleShowMore: function handleShowMore() {
      this.showAll = true;
    },
    defineComponentType: function defineComponentType(item) {
      return item.url ? 'link' : 'default';
    }
  }
};